import { render, staticRenderFns } from "./SearchSideBar.vue?vue&type=template&id=3b4eba38&"
import script from "./SearchSideBar.vue?vue&type=script&lang=js&"
export * from "./SearchSideBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchSideBar.vue?vue&type=style&index=0&id=3b4eba38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports